import styled, { css } from 'styled-components'
import { TextArea, Label } from 'semantic-ui-react'
import { Icon } from '@/ui'

export const StyledTextArea = styled(TextArea)`
  &&& {
    width: 300px;
    min-height: 150px;
  }
`

export const EditorWrapper = styled.div`
  width: 300px;
  min-height: 150px;
`

export const LabelIcon = styled(Icon)`
  &&& {
    font-size: 12px !important;
    top: 0px !important;
    margin-right: 0.5em;
    top: 2px;
  }
`
export const Footer = styled.div`
  position: absolute;
  left: calc(100% - 2em);
  bottom: 0;
`

export const TriggerLabel = styled(Label).attrs({
  as: 'a',
})`
  ${({ autoHeight, theme }) => css`
    display: inline-flex;
    background: ${theme.colors.lightGrey};
    white-space: nowrap;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 300 !important;
    padding: 5px 10px;
    height: ${autoHeight ? 'auto' : '26px'};

    line-height: 1em;

    * {
      font-weight: 300 !important;
    }

    img {
      width: 25px;
      height: 25px;
      margin: -5px 5px -5px -10px;
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &,
    :hover {
      color: #012d3e !important;
    }
  `}
`
